

/**
 * Surcharge des requêtes AJAX avant envoi et après complétion
 */
var csrfToken = {
    init: function () {

        // Ajout systématique d'un header contenant le token CSRF, qui permet d'éviter des attaques CSRF.
        $(document).ajaxSend(function (event, xhr, settings) {
            xhr.setRequestHeader("X-CSRF-TOKEN", $('meta[name="csrf-token"]').attr('content'))
        });

        // Appel des ressources CSS si des URLs ont été données
        $(document).ajaxComplete(function (event, xhr, settings) {
            if (xhr.responseJSON && xhr.responseJSON.css) {
                if (xhr.responseJSON.css.constructor === Array) {
                    for (var i in xhr.responseJSON.css) {
                        addCSS(xhr.responseJSON.css[i]);
                    }
                }
                else {
                    addCSS(xhr.responseJSON.css);
                }
            }
        });

    }
};

/**
 * Objet effectuant les changements visuels lorsqu'on souhaite signaler un état de chargement.
 *
 * @type {{elems: null, start: loadingState.start, end: loadingState.end}}
 */
var loadingState = {
    elems: null,

    /**
     * Démarre l'état de "chargement".
     * Il est possible de passer des éléments supplémentaires en paramètre
     * @param elems
     */
    start: function (elems) {
        $('html,body').css('cursor', 'progress');
        if (typeof elems !== 'undefined') {
            this.elems = elems.add(this.elems);
            this.elems.css('cursor', 'progress');
        }
    },

    /**
     * Stoppe l'état de "chargement". Si des éléments supplémentaires ont été définis dans le start(),
     * ils sont remis à leur état de base puis la variable est vidée.
     */
    end: function () {
        $('html,body').css('cursor', '');
        if (this.elems) {
            this.elems.css('cursor', '');
            this.elems = null;
        }
    }
};

/**
 */
var overlay = {
    $selector: $('.overlay'),

    show: function () {
        this.$selector.addClass('visible');
    },

    hide: function () {
        this.$selector.removeClass('visible');
    }
};



(function ($) {

    // Vu que dans PatternLab on est dans une iframe, on doit faire référence à top.
    window.alert = top.alert;
    window.confirm = top.confirm;
    window.prompt = top.prompt;


    csrfToken.init();

})(jQuery);

